import React from "react";
import "./style.css";

export const Top = ({sku, time, scrollToTarget, showDiscountInfo = true}) => {
  return (
    <div className="top">
      <div className="download">
        <div className="time">
          {sku.discount !== 0 && <div className="frame" style={{ visibility: showDiscountInfo ? "visible" : "hidden" }}>
            <div className="discount-message">{sku.discount}% discount reserved for:</div>
          </div>}


          <div className="countdown-timer">{time}</div>
        </div>

        <button className="button btn-ripple">
          <div className="button-text" onClick={scrollToTarget}>Get My Plan</div>
        </button>
      </div>
    </div>
  );
};
